import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import ModalOverlay from "../../components/ModalOverlay";

import heroMobileImage from '../../images/articles/P00138022_WF_BRAND_FY25_ISF_AprUpdate20_LP_767x577.jpg';
import heroDesktopImage from '../../images/articles/P00138022_WF_BRAND_FY25_ISF_AprUpdate20_LP_1164x584.jpg';

import { fireTag } from '../../libs/analytics.js';

const AviationFuel = ({
    handleEvent,
    closeExitOverlay,
    addExitClickListeners,
    modalOverlay,
}) => {

    const [enableScrollGA, setEnableScrollGA] = useState(false);
    const [shouldBeInert, setShouldBeInert] = useState(false);
    const [gridVisible, setGridVisible] = useState(false);

    const heroOGImage = 'P00138022_WF_BRAND_FY25_ISF_AprUpdate20_LP_ogimage';

	addExitClickListeners();

    const toggleInert = () => {
        setShouldBeInert(!shouldBeInert)
    }

    const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}

    let mastheadImage = window.innerWidth < 768 ? heroMobileImage : heroDesktopImage;

    return (
		<>
			<Helmet>
				<title>Exploring the flight path of sustainable aviation fuel</title>
				<meta
					name="description"
					content="The aviation industry’s “fuel of the future” needs increased investment and collaboration to reach cruising altitude."
				/>
				<meta property="og:title" content="Exploring the flight path of sustainable aviation fuel"/>
				<meta
					property="og:description"
					content="The aviation industry’s “fuel of the future” needs increased investment and collaboration to reach cruising altitude."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="Exploring the flight path of sustainable aviation fuel"/>
				<meta
					property="twitter:description"
					content="The aviation industry’s “fuel of the future” needs increased investment and collaboration to reach cruising altitude."
				/>
				i
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}

			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>

			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}


			<main className="flex-container">

				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
                        Exploring the flight path of sustainable aviation fuel                       
                        </h1>
						<h2 className="summary">
                        The aviation industry’s “fuel of the future” needs increased investment and collaboration to reach cruising altitude.
                        </h2>
					</div>

				</div>

				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="A woman walks through an airport pulling her luggage with airplane in the background."/>
					</div>
				</div>
                
				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
                    <div className="by-line">
							<p>By Elizabeth Meyers, <span>senior sustainable finance integration specialist at Wells Fargo</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>April 17, 2025</p>
							</div>
							<div>
								<p>5-minute read</p>
							</div>
						</div>
                    <p>Traditional jet fuel poses two challenges for the airline industry — it’s <a onClick={()=>fireTag('A1','a major expense')} target="_blank" href="https://www.transportation.gov/administrations/assistant-secretary-research-and-technology/what-cost-airline-fuel-means-you" rel="noreferrer" data-click-listener="true">a major expense</a> and it’s a big contributor of carbon emissions. The Environmental Protection Agency reports commercial airplanes and large business jets <a onClick={()=>fireTag('A1','contribute 10%')} target="_blank" href="https://www.epa.gov/regulations-emissions-vehicles-and-engines/regulations-greenhouse-gas-emissions-aircraft" rel="noreferrer" data-click-listener="true">contribute 10%</a> of U.S. transportation emissions.</p>
                    <p>Sustainable aviation fuel — commonly referred to as <a onClick={()=>fireTag('A1','saf')} target="_blank" href="https://afdc.energy.gov/fuels/sustainable-aviation-fuel" rel="noreferrer" data-click-listener="true">SAF</a> — is a prime alternative to help decarbonize the aviation industry, enhance energy security, and create new economic opportunities. SAF is a blend of conventional jet fuel and synthetic components made from renewable feedstocks, such as used cooking oils, plant oils, and municipal waste.</p>
                    <p>This low-carbon fuel can be used without changes to the <a onClick={()=>fireTag('A1','aircrafts fuel-handling infrastructure')} target="_blank" href="https://www.boeing.com/content/dam/boeing/boeingdotcom/principles/esg/SAF-fact-sheet.pdf" rel="noreferrer" data-click-listener="true">aircraft’s fuel-handling infrastructure</a>, making it easy to implement. However, financing gaps, high construction costs for new facilities, and limited labor and feedstock can make SAF production challenging and expensive. Public and private capital support, cross-industry collaboration, and regional solutions aim to address these seemingly sky-high obstacles.</p>
                    

                    <h2 className="subhead" style={{marginTop: '1rem'}}>
                        Banks can support clients from farm to flight
                    </h2>

                    <p>In October, Wells Fargo, Alaska Airlines, and the U.S. Department of Energy’s (DOE) Bioenergy Technologies Office hosted the Seattle Sustainable Aviation Fuel Pacific Northwest Workshop. The event brought together key players across the SAF value chain, including producers, investors, buyers, and government agencies. These participants discussed how increased investment can help advance SAF production while simultaneously <a onClick={()=>fireTag('A1','supporting the agriculture sector')} target="_blank" href="https://www.weforum.org/stories/2023/01/sustainable-aviation-fuels-carbon-footprint-davos23/" rel="noreferrer" data-click-listener="true">supporting the agriculture sector</a> to increase energy independence in the U.S.</p>
                    <p>Currently, the main <a onClick={()=>fireTag('A1','commercial pathway')} target="_blank" href="https://www.nrel.gov/docs/fy24osti/87803.pdf" rel="noreferrer" data-click-listener="true">commercial pathway</a> to produce SAF in the U.S. is hydroprocessed esters and fatty acids, which is also used to produce renewable diesel. The competition for feedstock can lead to limited supply and refinery capacity. But, with minor modifications, existing renewable diesel production infrastructure <a onClick={()=>fireTag('A1','can be converted')} target="_blank" href="https://advancedbiofuelsusa.info/renewable-diesel-hefa-plant-conversions-for-maximum-saf-production" rel="noreferrer" data-click-listener="true">can be converted</a> for SAF production, bypassing the challenges of new construction projects.</p>
                    <p>Scientific researchers and investors are also exploring new ways to expand SAF production methods. The <a onClick={()=>fireTag('A1','prairie research institute')} target="_blank" href="https://www.safinvestor.com/news/145940/plastic-waste/" rel="noreferrer" data-click-listener="true">Prairie Research Institute</a> discovered plastic waste can be transformed into SAF, while low-carbon, synthetic fuels — often called e-fuels — are widely seen as a solution to address feedstock challenges.</p>
                    </div>
                    </div>

                    <div className="flex-row full-width">
                        <div className="flex-row text-center">
                            <div className="flex-col-md-8 flex-col-sm-12 text-center content-box">
                                <div className="content-header" style={{borderTop:"2px solid #ffcd41"}}>
                                    <p style={{margin:"0"}}>Read the Wells Fargo Agri-Food Institute analysis:</p>
                                    <a onClick={()=>fireTag('A1','sustainable aviation fuel cleared for takeoff. Are u.s. feedstocks runway ready?')} target="_blank" href="https://www.wellsfargo.com/com/insights/agri-food-intelligence/saf-takeoff-feedstocks-ready/" rel="noreferrer" data-click-listener="false">Sustainable aviation fuel cleared for takeoff. Are U.S. feedstocks runway ready?</a>
                                </div>
                            </div>
                        </div>
                    </div>

                <div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center">
                    <h2 className="subhead" style={{marginTop: '1rem'}}>
                        Financial incentives aim to scale production and distribution
                    </h2>
                    <p>The International Air Transport Association expects SAF to contribute approximately <a onClick={()=>fireTag('A1','65% of the emissions reduction')} target="_blank" href="https://www.iata.org/en/programs/sustainability/sustainable-aviation-fuels/" rel="noreferrer" data-click-listener="true">65% of the emissions reduction</a> needed for the aviation sector to reach net zero. However, high costs and limited supplies are barriers to deployment.</p>
                    <p>SAF has a green premium — a higher cost over alternatives with higher greenhouse gas emissions — costing <a onClick={()=>fireTag('A1','two to ten times”')} target="_blank" href="https://www.energy.gov/articles/us-department-energy-releases-new-report-pathways-commercial-liftoff-sustainable-aviation" rel="noreferrer" data-click-listener="true">two to ten times</a> more than traditional jet fuel. Airlines often <a onClick={()=>fireTag('A1','pass along the cost of fuel')} target="_blank" href="https://onemileatatime.com/guides/airline-fuel-surcharges/" rel="noreferrer" data-click-listener="true">pass along the cost of fuel</a> to air travelers through a fuel or carrier-imposed surcharge, but <a onClick={()=>fireTag('A1','a national geographic survey')} target="_blank" href="https://www.nationalgeographic.com/travel/article/should-you-buy-carbon-offsets-for-your-air-travel" rel="noreferrer" data-click-listener="true">a National Geographic survey</a> found more than a third of Americans would pay extra to offset their flights’ carbon emissions.</p>
                    <p>In 2024, the U.S. <a onClick={()=>fireTag('A1','imported 24,000 barrels')} target="_blank" href="https://www.eia.gov/dnav/pet/hist/LeafHandler.ashx?n=pet&s=mkbimus2&f=a" rel="noreferrer" data-click-listener="true">imported 24,000 barrels</a> of jet fuel per day. Two bipartisan efforts could ease dependence on foreign fuels. The <a onClick={()=>fireTag('A1','synthetic aviation fuel grand challenge')} target="_blank" href="https://www.energy.gov/eere/bioenergy/synthetic-aviation-fuel-grand-challenge" rel="noreferrer" data-click-listener="true">Synthetic Aviation Fuel Grand Challenge</a> — a roadmap by the DOE, the U.S. Department of Transportation, and the U.S. Department of Agriculture (USDA) — aims to scale new technology and increase domestic energy production, while the recently introduced <a onClick={()=>fireTag('A1','farm to fly act of 2025')} target="_blank" href="https://www.grassley.senate.gov/imo/media/doc/farm_to_fly_act.pdf" rel="noreferrer" data-click-listener="true">Farm to Fly Act of 2025</a> supports SAF development to <a onClick={()=>fireTag('A1','promote energy security and independence”')} target="_blank" href="https://www.moran.senate.gov/public/index.cfm/2025/1/sen-moran-leads-colleagues-in-reintroducing-farm-to-fly-act-to-expand-use-of-biofuels-for-aviation?trk=feed-detail_main-feed-card_feed-article-content" rel="noreferrer" data-click-listener="true">promote energy security and independence</a> through USDA bio-energy programs.</p>
                    <p>In certain regions, state-level incentives can complement federal efforts to address financial challenges and improve access. For instance, Illinois offers an additional <a onClick={()=>fireTag('A1','saf purchase credit')} target="_blank" href="https://tax.illinois.gov/research/publications/bulletins/fy-2023-23.html" rel="noreferrer" data-click-listener="true">SAF purchase credit</a> of $1.50 per gallon purchased through 2032. This applies to SAF purchased for use in Illinois, which could encourage regional market growth.</p>
                    <p>Collaboration between airlines, SAF producers, and financial institutions can help to accelerate market growth. With continued investment, technological advancements, and federal and state-level support, the aviation industry can move closer to its goal of sustainable flight.</p>
					</div>
				</div>
			</main>


			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
		</>
    );

};

export default withRouter(AviationFuel);



